import angular from 'angular';
import ComponentsModule from '../components-module.js';

const COMPONENT_NAME = 'UiState';

angular.module (ComponentsModule)
  .factory (COMPONENT_NAME, ($window) => {
      
    return {
      get: (component, property) => {
        let uiState = $window.localStorage.getItem (COMPONENT_NAME) || '{}';

        if (!component) {
          return JSON.parse (uiState);
        } else {
          const componentState = JSON.parse (uiState)[component] || {};

          if (property) {
            return componentState[property];
          } else {
            return componentState;
          }
        }
      },

      set: (component, properties) => {
        let uiState = JSON.parse($window.localStorage.getItem (COMPONENT_NAME) || '{}');

        uiState[component] = Object.assign ({}, uiState[component] || {}, properties || {});
        $window.localStorage.setItem(COMPONENT_NAME, JSON.stringify(uiState));
      }
    };
  });

export default COMPONENT_NAME;
